type SupportedLanguageCode = 'pt' | 'en' | 'es';

export function getPostLanguageCode(lang: string | undefined): SupportedLanguageCode | null {
  const normalizedLang = (lang ?? '').trim().toLowerCase();

  if (normalizedLang === 'pt' || normalizedLang.startsWith('pt-')) return 'pt';
  if (normalizedLang === 'en' || normalizedLang.startsWith('en-')) return 'en';
  if (normalizedLang === 'es' || normalizedLang.startsWith('es-')) return 'es';

  return null;
}

export function getPostLanguageDisplayName(
  lang: string | undefined,
  t: (key: string) => string,
): string | null {
  const languageCode = getPostLanguageCode(lang);
  if (languageCode) return t(`cardPosts.postLanguages.${languageCode}`);

  return null;
}
